import { createStyles, Theme } from "@material-ui/core";
export const DialogLargeStyle = (theme: Theme) =>
  createStyles({
    dialog_footerFixed: {
      height: 66,
      padding: "10px 14px",
      boxShadow: "0px 2px 20px rgb(0 0 0 / 12%)",
      border: "1px solid rgb(238 238 238)",
      backgroundColor: "rgb(255 255 255)",
      position: "absolute",
      bottom: 0,
      right: 0,
      left: 0,
      '& button':{
        marginLeft: "auto",
        // maxWidth: 140,
        // width: "100%",
        display: "block",
      }
    },
    saveButon:{
      padding: '5px 24px',
      marginRight: 15
    },
    cardContainer: {
      margin: '-16px -10px',
      backgroundColor: 'rgb(251 251 251)',
      height: '100vh'
    },
    cardContentHeight: {
      height: "calc(100% - 134px)",
    },
    cardContent: {      
      overflowY: "auto",
      overflowX: "hidden",
      height: 'calc(100% - 128px)'
    },
    resetButton: {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: 0,
      backgroundColor: 'initial !important',
      color: '#666',
      padding: '0 !important',
      minWidth: 'initial',
      height: 'initial',
      marginRight: '30px !important',
    },
    modalHeader:{
      height:66,
      boxShadow: "0px 2px 20px rgb(0 0 0 / 12%)",
      borderBottom: "1px solid rgb(238 238 238)",
      backgroundColor: "rgb(255 255 255)",
    },
    title:{
      fontSize:24,
      textAlign: "left",
      fontWeight:600,
      lineHeight:32,
      paddingLeft:18,
    },
    fontWeight500:{
      fontWeight: 500,
    },
    fontSizeLG:{
      fontSize: "1.75rem"
    },
    ellipsis:{overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 600,
    textOverflow: 'ellipsis'}
  });

